import {
  createServiceApi,
  deleteServiceApi,
  getServicesApi,
  getSingleServiceByIdApi,
  updateServiceApi,
} from "api/services";
import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";
import {
  createServiceFailure,
  createServiceSuccess,
  deleteServiceFailure,
  deleteServiceSuccess,
  getServicesFailure,
  getServicesSuccess,
  getSingleServiceFailure,
  getSingleServiceSuccess,
  updateServiceFailure,
  updateServiceSuccess,
} from "./actions";
import {
  CREATE_SERVICE,
  DELETE_SERVICE,
  GET_SERVICES,
  GET_SINGLE_SERVICE,
  UPDATE_SERVICE,
} from "./actionTypes";

function* getServicesSaga({ payload }) {
  try {
    const { data } = yield call(getServicesApi, payload);
    yield put(getServicesSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getServicesFailure(error));
  }
}

// ===================================================
// ===================================================

function* getSingleServiceSaga({ payload }) {
  try {
    const { data } = yield call(getSingleServiceByIdApi, payload);
    yield put(getSingleServiceSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSingleServiceFailure(error));
  }
}

// ===================================================
// ===================================================

function* createServiceSaga({ payload }) {
  try {
    const { data, success } = yield call(createServiceApi, payload);
    yield put(createServiceSuccess(data));
    if (success) {
      yield payload?.toast?.success("تم اضافة الخدمة بنجاح");
      yield payload?.navigate("/services");
    }
  } catch (error) {
    console.log(error);
    yield put(createServiceFailure(error));
  }
}

// ===================================================
// ===================================================

function* updateServiceSaga({ payload }) {
  try {
    const { data, success } = yield call(updateServiceApi, payload);
    yield put(updateServiceSuccess(data));
    if (success) {
      yield payload?.toast?.success("تم تعديل الخدمة بنجاح");
      yield payload?.navigate("/services");
    }
  } catch (error) {
    console.log(error);
    yield put(updateServiceFailure(error));
  }
}

// ===================================================
// ===================================================

function* deleteServiceSaga({ payload }) {
  try {
    yield call(deleteServiceApi, payload);
    yield put(deleteServiceSuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deleteServiceFailure(error));
  }
}

// ===================================================
// ===================================================

export function* watchGetServices() {
  yield takeEvery(GET_SERVICES, getServicesSaga);
}

export function* watchGetSingleService() {
  yield takeLatest(GET_SINGLE_SERVICE, getSingleServiceSaga);
}

export function* watchCreateService() {
  yield takeLatest(CREATE_SERVICE, createServiceSaga);
}

export function* watchUpdateService() {
  yield takeLatest(UPDATE_SERVICE, updateServiceSaga);
}
export function* watchDeleteService() {
  yield takeLatest(DELETE_SERVICE, deleteServiceSaga);
}

// ===================================================
// ===================================================

function* servicesSaga() {
  yield all([fork(watchGetServices)]);
  yield all([fork(watchGetSingleService)]);
  yield all([fork(watchDeleteService)]);
  yield all([fork(watchUpdateService)]);
  yield all([fork(watchCreateService)]);
}

export default servicesSaga;
